/* eslint-disable */
<template>
  <!-- eslint-disable -->
  <b-container>
    <b-row>
      <b-col sm="12">
        <b-alert :show="showAlert" dismissible>{{ alert }}</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h2>Search category definitions</h2>
      </b-col>
      <b-col>
        <b-form-input
          v-model="search"
          placeholder="Search for category definitions"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card
          v-for="categoryDefinition in categoryDefinitions"
          :key="categoryDefinition.id"
        >
          <b-container>
            <b-row>
              <b-col sm="4">
                <b-link
                  :to="{
                    name: 'EditCategoryDefinition',
                    params: { id: categoryDefinition._id },
                  }"
                >
                  {{ categoryDefinition.display_name }}
                </b-link>
                <div
                  class="category-description"
                  v-if="categoryDefinition.description"
                >
                  {{ categoryDefinition.description }}
                </div>
              </b-col>
              <b-col sm="6">
                <span v-if="categoryDefinition.class === 'simple'">
                  {{ categoryDefinition.type.display_name }}:
                  {{ categoryDefinition.data }}
                </span>
                <span v-else>
                  Attributes:
                  {{ categoryDefinition.attributes | display_names }}
                </span>
              </b-col>
              <b-col sm="2">
                <b-button
                  @click="deleteCategoryDefinition(categoryDefinition._id)"
                  >Remove</b-button
                >
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
/* eslint-disable */

import { API } from '../../api';
import forEach from 'lodash/forEach';

const api = new API();

export default {
  name: 'CategoryDefinitions',
  data() {
    return {
      search: '',
      categoryDefinitions: [],
      alert: null,
      showAlert: false,
    };
  },
  mounted() {
    this.getCategoryDefinitions();
  },
  methods: {
    showErrorMessage(msg) {
      this.alert = msg;
      this.showAlert = true;
    },
    deleteCategoryDefinition(id) {
      let me = this;
      api
        .deleteOne('terms', id)
        .then((response) => {
          me.getCategoryDefinitions();
        })
        .catch((error) => {
          me.showErrorMessage(error);
        });
    },
    getCategoryDefinitions() {
      let me = this;
      let filter = {};
      api
        .find('terms', filter)
        .then((response) => {
          let categoryDefinitions = response.data;
          me.categoryDefinitions = [];
          forEach(categoryDefinitions, function(categoryDefinition) {
            if (
              !me.search ||
              (categoryDefinition.display_name &&
                categoryDefinition.display_name
                  .toLowerCase()
                  .includes(me.search.toLowerCase()))
            ) {
              me.categoryDefinitions.push(categoryDefinition);
            }
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  watch: {
    search: function(val) {
      this.getCategoryDefinitions();
    },
  },
};
</script>

<style scoped>
.category-description {
  font-style: italic;
  font-size: 80%;
}
.card-body {
  padding: 0.5rem;
}
.card {
  border: None;
}
.card:nth-child(even) {
  background-color: white;
}
.card:nth-child(odd) {
  background-color: #eee;
}
</style>
